import { Link } from 'react-router-dom';

const footerLinks = {
  产品: [
    { label: '合同起草', to: '/category/hetong-qicao' },
    { label: '方案策划', to: '/category/fangan-cehua' },
    { label: '创意内容', to: '/category/chuangyi-neirong' },
    { label: '文档模板', to: '/category/wendang-moban' },
  ],
  资源: [
    { label: '帮助中心', to: '/about' },
    { label: '使用教程', to: '/category/tuandui-xiezuo' },
    { label: '常见问题', to: '/about' },
    { label: '更新日志', to: '/about' },
  ],
  公司: [
    { label: '关于我们', to: '/about' },
    { label: '联系我们', to: '/about' },
    { label: '隐私政策', to: '/about' },
    { label: '服务条款', to: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block cursor-pointer">
              <span className="text-xl font-heading font-bold text-background-50">
                一起草<span className="text-primary-400">.com</span>
              </span>
            </Link>
            <p className="mt-4 text-sm text-background-400 leading-relaxed max-w-sm">
              专业在线文稿协作平台，支持多人实时共同起草文件、合同、方案与创意内容。让每一份文稿从构思到定稿都更高效、更顺畅。
            </p>
            <div className="flex items-center gap-4 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">{title}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {new Date().getFullYear()} 一起草.com 版权所有
          </p>
          <p className="text-sm text-background-500">
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow noopener" className="hover:text-background-300 transition-colors cursor-pointer">
              京ICP备2024XXXXXXXX号
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}